/**
 * Abre link do WhatsApp (wa.me). Em mobile, popups costumam ser bloqueadas:
 * usa a mesma aba para o sistema abrir o app; no desktop mantém nova aba.
 */
export function openWhatsAppUrl(url){
	if(!url || typeof url !== 'string') return;
	const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
		typeof navigator !== 'undefined' ? navigator.userAgent : ''
	);
	if(mobile){
		window.location.assign(url);
	}else{
		window.open(url, '_blank', 'noopener,noreferrer');
	}
}
